/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.urls.rpc.ScreenshotRpc
 */
import * as References from './ScreenshotRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.urls.rpc.ScreenshotRpc#getScreenshot
 */
export const GET_SCREENSHOT_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_urls_rpc_ScreenshotRpc_getScreenshot';
export const GET_SCREENSHOT_QUERY: RegisteredQuery<
  'result',
  References.GetScreenshotRequestType,
  References.GetScreenshotResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SCREENSHOT_QUERY_FIELD_NAME,
  args: ['siteKey', 'path', 'language'],
  fetcher(
    request: References.GetScreenshotRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetScreenshotResponseType> {
    return (ctx.customClient ?? chirpClient).call(References.getScreenshotRpc, {
      timeout: ctx.timeout,
      request,
    });
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.urls.rpc.ScreenshotRpc#getScreenshotV2
 */
export const GET_SCREENSHOT_V2_QUERY_FIELD_NAME =
  'com_hubspot_marketplace_urls_rpc_ScreenshotRpc_getScreenshotV2';
export const GET_SCREENSHOT_V2_QUERY: RegisteredQuery<
  'result',
  References.GetScreenshotV2RequestType,
  References.GetScreenshotV2ResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SCREENSHOT_V2_QUERY_FIELD_NAME,
  args: ['siteKey', 'path', 'language'],
  fetcher(
    request: References.GetScreenshotV2RequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetScreenshotV2ResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getScreenshotV2Rpc,
      { timeout: ctx.timeout, request }
    );
  },
});
